import {
    CLEAR_RESULT,
    MODIFIED_RESULT,
    PUBLISH_RESULT,
    UPDATE_RESULT,
    LIST_RESULT_V1,
    FETCH_RESULT_V1,
    PUBLISHED_RESULT
} from "./types";


const init = {
    isLoading: false,
    filter: {},
    results: [],
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_RESULT_V1:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case MODIFIED_RESULT :
            return {
                ...state,
                isLoading: true
            };
        case LIST_RESULT_V1:
            return {
                ...state,
                isLoading: false,
                ...payload
            };
        case UPDATE_RESULT:
            return {
                ...state,
                isLoading: false,
                ...payload
            };
        case PUBLISH_RESULT:
            return {
                ...state,
                isLoading: true,
            };
        case PUBLISHED_RESULT:
            return {
                ...state,
                isLoading: false,
            };

        case CLEAR_RESULT:
            return {
                ...init
            };
        default:
            return state;
    }
}
